import { styled } from "styled-components";

export const CustomDatePicker = styled.div`
  .rmdp-container {
    width: 100%;
  }
  .rmdp-input {
    border: 1px solid #d9d9d9;
    border-radius: 6px;
    height: auto;
    width: 100%;
    padding: 8px;
    &::placeholder {
      color: #d9d9d9;
      font-size: 12px;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    &:hover,
    &:focus,
    &:focus-within {
      border-color: #5c61ff;
    }
  }
`;

export default CustomDatePicker;
